export default class TopicCategory extends String{
  static readonly LegalEntities = {
    EntityMember: 'LegalEntities.EntityMember',
    EntityMemberInvitation: 'LegalEntities.EntityMemberInvitation',
    LegalEntity: 'LegalEntities.LegalEntity',
    // A firm's own roster of colleagues, asked for once its Attorney Hub proposal is hired. The
    // topic id is the firm, not a record of the request: there is no roster row to open, only the
    // page where the roster is entered.
    TeamRoster: 'LegalEntities.TeamRoster'
  };
  static readonly Marketplace = {
    // New profiles that match a search a user saved. The topic id is the saved search.
    SavedSearch: 'Marketplace.SavedSearch',
    // A person's own profile, hidden until it lists professional credentials. The topic id is their
    // individual (#6608).
    IndividualVisibility: 'Marketplace.IndividualVisibility',
    Team: 'Marketplace.Team',
    TeamInvitation: 'Marketplace.TeamInvitation'
  };
  static readonly Permissions = {
    // A member asking for access they lack (#6596). The topic id is the request: its grantors are
    // asked to decide it, and its requester is told the decision.
    AccessRequest: 'Permissions.AccessRequest'
  };
  static readonly Messaging = {
    Forum: 'Messaging.Forum',
    ForumInvitation: 'Messaging.ForumInvitation'
  };
  static readonly Users = {
    NetworkInvitation: 'Users.NetworkInvitation',
    NetworkConnection: 'Users.NetworkConnection'
  };
  static readonly Work = {
    Proposal: 'Work.Proposal',
    // A policy replacement. The topic id is the replacement: its requester hears how the first pass
    // went, and of each agreement that stops or needs a person (#6256).
    PolicyReplacement: 'Work.PolicyReplacement',
    Agreement: 'Work.Agreement'
  };
}
